import Cookies from 'js-cookie'
import jwt from 'jsonwebtoken'

const BSRS_ACCESS_TOKEN = 'bsrs_access_token'
const ACCESS_TOKEN = 'access_token'
const BACKUP_ACCESS_TOKEN = 'backup_access_token'
const EXPIRES_ON = 'expires_on'
const USER_EMAIL = 'user_email'
const USER_ID = 'user_id'
const IS_AGREE = 'isAgreeTermAndCondition'
const FULL_NAME = 'fullName'
const EMP_ID = 'employeeId'
const ROLE = 'role'
const IS_EXECUTIVE = 'isExecutive'
const AMENITY = 'AmenityPage'
const IS_ACTIVE = 'isActive'
const AMENITYSERVICE_FLOOR = 'AMENITYSERVICE_FLOOR'
const MIN_STEP = "min_step"

function getCookie(key) {
    return Cookies.get(key)
}

function setCookie(key, value) {
    Cookies.set(key, value)
}

function removeCookie(key) {
    Cookies.remove(key)
}

export function getAccessToken() {
    return getCookie(ACCESS_TOKEN)
}
export function getBackupAccessToken() {
    return getCookie(BACKUP_ACCESS_TOKEN)
}
export function getIsActive() {
    return getCookie(IS_ACTIVE) === 'true'
}

export function getIsExecutive() {
    return getCookie(IS_EXECUTIVE) === 'true'
}

export function getAllToken() {

    if (!getCookie(ACCESS_TOKEN)) return {}
    return {
        access_token: getCookie(ACCESS_TOKEN),
        user_email: getCookie(USER_EMAIL),
        user_id: getCookie(USER_ID),
        expired_on: getCookie(EXPIRES_ON),
        isAgreeTermAndCondition: getCookie(IS_AGREE),
        fullName: getCookie(FULL_NAME),
        employeeId: getCookie(EMP_ID),
        role: getCookie(ROLE),
        isExecutive: getCookie(IS_EXECUTIVE),
    }
}

export function getAmenityToken() {
    return {
        amenity: getCookie(AMENITY)
    }
}

export function setToken(props) {
    clearBSRSToken()
    const { token, email, userId, expires_date_on, isAgreeTermAndCondition, employeeId, fullName, role, isExecutive, isActive } = props
    if (typeof token !== "undefined") setCookie(ACCESS_TOKEN, token)
    if (typeof token !== "undefined") setCookie(BACKUP_ACCESS_TOKEN, token)
    if (typeof email !== "undefined") setCookie(USER_EMAIL, email)
    if (typeof userId !== "undefined") setCookie(USER_ID, userId)
    if (typeof expires_date_on !== "undefined") setCookie(EXPIRES_ON, expires_date_on)
    if (typeof isAgreeTermAndCondition !== "undefined") setCookie(IS_AGREE, isAgreeTermAndCondition)
    if (typeof fullName !== "undefined") setCookie(FULL_NAME, fullName)
    if (typeof employeeId !== "undefined") setCookie(EMP_ID, employeeId)
    if (typeof role !== "undefined") setCookie(ROLE, role)
    if (typeof isExecutive !== "undefined") setCookie(IS_EXECUTIVE, isExecutive)
    setCookie(IS_ACTIVE, isActive)
}

export function clearToken() {
    removeCookie(ACCESS_TOKEN)
    removeCookie(USER_EMAIL)
    removeCookie(USER_ID)
    removeCookie(IS_AGREE)
    removeCookie(FULL_NAME)
    removeCookie(EMP_ID)
    removeCookie(ROLE)
    removeCookie(IS_EXECUTIVE)
    removeCookie(IS_ACTIVE)
}

export function setCookieSetting(setting) {
    if (!!setting) {
        if (!isNaN(parseInt(setting.slotDuration, 0))) {
            setCookie(MIN_STEP, parseInt(setting.slotDuration, 0))
        }
    }
}

export function getMinStep() {
    let minStep = parseInt(getCookie(MIN_STEP), 10)
    if (!isNaN(minStep) && getCookie(MIN_STEP) > 0) {
        return minStep
    } else {
        return 30
    }
}

export function getUserInfo(access_token) {
    if (!access_token) return {}
    const {
        iat,
        exp,
        appid,
        name,
        unique_name: email
    } = jwt.decode(access_token)

    return {
        iat,
        exp,
        appid,
        name,
        email
    }
}
export function setIsAgree() {
    return setCookie(IS_AGREE, true)
}
export function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN)
}

export function getfullName() {
    return getCookie(FULL_NAME)
}

export function getUserId() {
    return getCookie(USER_ID)
}

export function setBSRSToken(access_token) {
    setCookie(BSRS_ACCESS_TOKEN, access_token)
}

export function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN)
    removeCookie(ACCESS_TOKEN)
    removeCookie(USER_EMAIL)
    removeCookie(USER_ID)
    removeCookie(EXPIRES_ON)
    removeCookie(IS_AGREE)
    removeCookie(FULL_NAME)
    removeCookie(EMP_ID)
    removeCookie(ROLE)
    removeCookie(IS_ACTIVE)
}

export function clearBackupAccessToken() {
    removeCookie(BACKUP_ACCESS_TOKEN)
}

export function setAmenityserviceFloor(value) {
    removeCookie(AMENITYSERVICE_FLOOR)
    setCookie(AMENITYSERVICE_FLOOR, value)
}

export function getAmenityserviceFloor() {
    return getCookie(AMENITYSERVICE_FLOOR)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js